import { DetailedServiceBookingData } from "../Domain/RemoteOrderRequests.types";

export const applyServiceId = (data: DetailedServiceBookingData): DetailedServiceBookingData => {
  return {
    ...data,
    caterings: data.caterings.map(cat => ({ ...cat, serviceId: cat.id })),
    equipments: data.equipments.map(equip => ({ ...equip, serviceId: equip.id })),
    roomLayouts: data.roomLayouts.map(layout => ({ ...layout, serviceId: layout.id }))
  };
};
